import { createLogger } from "utils/logging";
import { Cinema } from "../cinema-module/cinema";

const log = createLogger("cinema", "pdp");
log.info("Initialize PdPCinema");

const cinema = new Cinema();
cinema.init(1);
